<!--
* @Description: 单票下单
* @Author: ganjia
* @Date: 2019-10-15 14:10:50
-->
<template>
  <div class="main-wrap singleOrder">
    <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
      <el-row :gutter="24">
        <el-col :span="12">
          <h3>{{ $lang('寄件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-autocomplete
                :maxlength="30"
                valueKey="name"
                v-model="formData.senderName"
                @select="changeSenderName"
                :fetch-suggestions="remoteSenderName"
                :placeholder="$lang('请输入寄件人姓名')">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(1)"></i>
                </template>
              </el-autocomplete>
            </el-form-item>
            <!-- <el-form-item :label="$lang('电话区号')" class="el-form-item w80 el-form-item--small" id="areaCodeSty">
               <template slot="label"><span :title="$lang('电话区号')">{{$lang('电话区号')}}</span></template>
               <el-input v-model="formData.senderPhoneAreacode" :disabled="true"></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('手机')" prop="senderMobilePhone" class="formPhone">
              <template slot="label"><span :title="$lang('手机')">{{ $lang('手机') }}</span></template>
              <BasePhoneInput v-model="formData.senderMobilePhone" :maxlength="16"></BasePhoneInput>
              <!-- <el-autocomplete
                  valueKey="mobile"
                  @select="changeSenderName"
                  v-model="formData.senderMobilePhone"
                  :fetch-suggestions="remoteSenderMobilePhone"
                  :placeholder="$lang('请输入寄件人手机')">
              </el-autocomplete> -->

            </el-form-item>
            <el-form-item :label="$lang('公司')" prop="senderCompany">
              <template slot="label"><span :title="$lang('公司')">{{ $lang('公司') }}</span></template>
              <el-input v-model.trim="formData.senderCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮编')">{{ $lang('邮编') }}</span></template>
              <el-input v-model.trim="formData.senderPostalCode" :minlength="1" :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮箱')">{{ $lang('邮箱') }}</span></template>
              <el-input v-model.trim="formData.senderEmail" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item :label="senderProvinceName" prop="senderProvinceName">
              <el-select v-model="formData.senderProvinceName" filterable @change="dataProvinceChange($event,1)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="senderCityName" prop="senderCityName">
              <el-select v-model="formData.senderCityName" filterable @change="dataCityChange($event,1)">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="senderAreaName" prop="senderAreaName" v-if="userInfo.countryId === 1">
              <el-select v-model="formData.senderAreaName" filterable @change="dataAreaChange($event,1)">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('寄件街道')" prop="senderStreet">
              <template slot="label"><span :title="$lang('寄件街道')">{{ $lang('寄件街道') }}</span></template>
              <el-input v-model="formData.senderStreet" :placeholder="$lang('请输入寄件街道')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-tooltip :disabled="senderShortAddressDisabled" class="item" effect="dark" placement="bottom-start">
              <div slot="content" style="cursor: pointer;max-width: 250px;" @click="handleCopy(senderShortAddressParseResults)">
                {{ senderShortAddressParseResults }}
              </div>
              <el-form-item v-if="userInfo.countryId === 1" :label="$lang('寄件短地址')" prop="senderShortAddress">
                <template slot="label"><span :title="$lang('寄件短地址')">{{ $lang('寄件短地址') }}</span></template>
                <el-input v-model="formData.senderShortAddress" :placeholder="$lang('请输入寄件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress($event, 'senderShortAddressParseResults', 'senderShortAddress')" />
              </el-form-item>
            </el-tooltip>
            <el-form-item v-if="userInfo.countryId === 1" :label="$lang('寄件建筑物编号')" prop="senderBuildingNumber">
              <template slot="label"><span :title="$lang('寄件建筑物编号')">{{ $lang('寄件建筑物编号') }}</span></template>
              <el-input v-model="formData.senderBuildingNumber" :placeholder="$lang('请输入寄件建筑物编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item v-if="userInfo.countryId === 1" :label="$lang('寄件辅助编号')" prop="senderReferenceNumber">
              <template slot="label"><span :title="$lang('寄件辅助编号')">{{ $lang('寄件辅助编号') }}</span></template>
              <el-input v-model="formData.senderReferenceNumber" :placeholder="$lang('请输入寄件辅助编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item class="el-form-item w360 el-form-item--small" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1" :maxlength="200"></el-input>
              <el-checkbox v-model="checkSenderFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-content">

            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <!-- <el-input v-model="formData.receiverName" :placeholder="$lang('请输入收件人姓名')"   :minlength="1"  :maxlength="12" > -->
              <el-autocomplete
                :maxlength="30"
                valueKey="name"
                v-model="formData.receiverName"
                @select="changeReceiverName"
                :fetch-suggestions="remoteReceiverName"
                :placeholder="$lang('请输入收件人姓名')">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="open(2)"></i>
                </template>
              </el-autocomplete>
              <!-- </el-input> -->
            </el-form-item>
            <!-- <el-form-item :label="$lang('电话区号')" class="el-form-item w80 el-form-item--small" id="areaCodeSty">
               <template slot="label"><span :title="$lang('电话区号')">{{$lang('电话区号')}}</span></template>
               <el-input v-model="formData.receiverPhoneAreacode" :disabled="true"></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('手机')" prop="receiverMobilePhone" class="formPhone">
              <template slot="label"><span :title="$lang('手机')">{{ $lang('手机') }}</span></template>
              <!-- <el-input v-model="formData.receiverMobilePhone" :maxlength='15'  :placeholder="$lang('请输入收件人手机电话')"></el-input> -->
              <BasePhoneInput v-model="formData.receiverMobilePhone" :maxlength="16"></BasePhoneInput>
              <!-- <el-autocomplete
                valueKey="mobile"
                @select="changeReceiverName"
                v-model="formData.receiverMobilePhone"
                :fetch-suggestions="remoteReceiverMobilePhone"
                :placeholder="$lang('请输入收件人手机')">
            </el-autocomplete> -->
            </el-form-item>
            <el-form-item :label="$lang('备用号码')" prop="receiverTelphone" class="formPhone">
              <template slot="label"><span :title="$lang('备用号码')">{{ $lang('备用号码') }}</span></template>
              <BasePhoneInput :maxlength="16" v-model="formData.receiverTelphone"></BasePhoneInput>
            </el-form-item>
            <el-form-item :label="$lang('公司')" prop="receiverCompany">
              <template slot="label"><span :title="$lang('公司')">{{ $lang('公司') }}</span></template>
              <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item :label="$lang('邮编')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮编')">{{ $lang('邮编') }}</span></template>
              <el-input v-model.trim="formData.receiverPostalCode" :minlength="1" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('邮箱')" id="areaCodeSty">
              <template slot="label"><span :title="$lang('邮箱')">{{ $lang('邮箱') }}</span></template>
              <el-input v-model.trim="formData.receiverEmail" :minlength="1" :maxlength="30"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('酋长国/区域')" prop="receiverProvince">
                <BaseAddressCope ref="receiverProvinceSearch" :initAddressData="receiverAddressData" :showLevel="3" v-model="formData.receiverProvince"> </BaseAddressCope>
            </el-form-item> -->
            <el-form-item :label="receiverProvinceName" prop="receiverProvinceName">
              <el-select v-model="formData.receiverProvinceName" filterable @change="dataProvinceChange($event,2)">
                <el-option
                  v-for="item in provinceArray"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="receiverCityName" prop="receiverCityName">
              <el-select v-model="formData.receiverCityName" filterable @change="dataCityChange($event,2)">
                <el-option
                  v-for="item in cityList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="receiverAreaName" prop="receiverAreaName" v-if="userInfo.countryId === 1">
              <el-select v-model="formData.receiverAreaName" filterable @change="dataAreaChange($event,2)">
                <el-option
                  v-for="item in areaList2"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
              <template slot="label"><span :title="$lang('收件街道')">{{ $lang('收件街道') }}</span></template>
              <el-input v-model="formData.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-tooltip :disabled="receiverShortAddressDisabled" class="item" effect="dark" placement="bottom-start">
              <div slot="content" style="cursor: pointer;max-width: 250px;" @click="handleCopy(receiverShortAddressParseResults)">
                {{ receiverShortAddressParseResults }}
              </div>
              <el-form-item v-if="userInfo.countryId === 1" :label="$lang('收件短地址')" prop="receiverShortAddress">
                <div class="label-tip" slot="label">
                  <span :title="$lang('收件短地址')">{{ $lang('收件短地址') }}</span>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content" class="short-tips">
                      <div>{{ $lang('Short address is a project from Saudi Arabia goverment.') }}</div>
                      <div>{{ $lang(' Introduction') }}:</div>
                      <a href="https://splonline.com.sa/en/national-address-1/" target="_blank">https://splonline.com.sa/en/national-address-1/</a>
                      <div>{{ $lang('Map for National address') }}:</div>
                      <a href="https://maps.splonline.com.sa" target="_blank">https://maps.splonline.com.sa</a>
                    </div>
                    <img class="tooltip-click" src="@/assets/images/exclamation-mark-icon.svg" alt="">
                  </el-tooltip>
                  <span>:</span>
                </div>
                <el-input v-model="formData.receiverShortAddress" :placeholder="$lang('请输入收件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress($event, 'receiverShortAddressParseResults', 'receiverShortAddress')" />
              </el-form-item>
            </el-tooltip>

            <el-form-item v-if="userInfo.countryId === 1" :label="$lang('收件建筑物编号')" prop="receiverBuildingNumber">
              <template slot="label"><span :title="$lang('收件建筑物编号')">{{ $lang('收件建筑物编号') }}</span></template>
              <el-input v-model="formData.receiverBuildingNumber" :placeholder="$lang('请输入收件建筑物编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item v-if="userInfo.countryId === 1" :label="$lang('收件辅助编号')" prop="receiverReferenceNumber">
              <template slot="label"><span :title="$lang('收件辅助编号')">{{ $lang('收件辅助编号') }}</span></template>
              <el-input v-model="formData.receiverReferenceNumber" :placeholder="$lang('请输入收件辅助编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>

            <el-form-item class="el-form-item el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1" :maxlength="200"></el-input>
              <el-checkbox v-model="checkReceiverFlag" style="margin-left:15px">{{ $lang('保存至地址簿') }}</el-checkbox>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('件数')" prop="packageNumber">
              <el-input-number v-model="formData.packageNumber" :label="$lang('描述文字')" step-strictly :min="1" :max="999"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('物品类型')" prop="goods" ref="goods">
              <Base-Select v-model="formData.goods" :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
              <el-input-number v-model="formData.packageTotalWeight" :label="$lang('描述文字')" :precision="2" :min="0" :max="99999.99"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('结算方式')" prop="payment">
              <Base-Select v-model="formData.payment" :disabled="true" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('支付方式')" prop="paidMode">
              <Base-Select v-model="formData.paidMode" :props="{label:'name',value:'code', res:'appPayTypeVOList',valueObj:true}" :disabled="paidOption"
                           dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')">
              </Base-Select>
            </el-form-item>

            <!-- 0510新增产品类型 -->
            <el-form-item :label="$lang('产品类型')" prop="expressType">
              <Base-Select v-model="formData.expressType" :props="{label:'productName',value:'productCode', res:'appProductTypeVOList',valueObj:true}"
                           :dic="someExpressTypeData" :placeholder="$lang('请选择')">
              </Base-Select>
            </el-form-item>

            <el-form-item :label="$lang('参考运费')" prop="standardValue">
              <el-input v-model="formData.standardValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('箱材规格')" prop="boxStandard">
                <Base-Select v-model="formData.boxStandard"
                    :props="{label:'name',value:'id', res:'records',valueObj:true}"
                    dicUrl="/vip/material/getMaterialSalesPrice"
                    :placeholder="$lang('请选择')">
                </Base-Select>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('箱材数量')" prop="boxNumber">
                 <el-input-number v-model="formData.boxNumber" label="描述文字" :step="1" :precision="0" :min="0" :max="99"></el-input-number>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('箱材单价')" prop="boxPrice">
                 <el-input v-model="formData.boxPrice" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item> -->
            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
              <template slot="label"><span :title="$lang('客户订单号')">{{ $lang('客户订单号') }}</span></template>
              <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$lang('代收货款币别')" prop="boxPrice">
              <el-select v-model="formData.senderProvinceName">
                <el-option>DHS</el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="$lang('平台')" prop="platformName">
              <el-input v-model.trim="formData.platformName" :placeholder="$lang('请输入电商平台名称')" :minlength="1" :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('客户账号')" prop="customerAccount">
              <el-input class="customerStyle" v-model.trim="formData.customerAccount" :placeholder="$lang('请输入电商平台客户账号')" :minlength="1" :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item class="cod">
              <el-checkbox class="btn-insured" v-model="codFlag" @change="checkCod" :disabled='isReverse'>{{ $lang('是否代收货款') }}</el-checkbox>
            </el-form-item>

            <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
              <el-select v-model="formData.codCurrencyTypeName" :disabled="true">
                <el-option
                  v-for="item in codCurrencyType"
                  :key="item.codCurrencyTypeCode"
                  :label="item.codCurrencyTypeName"
                  :value="item.codCurrencyTypeCode"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
              <el-input v-model="formData.codMoney" :label="$lang('描述文字')" :disabled="codIsInput" :placeholder="$lang('请输入对应的金额')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('代收货款手续费')" prop="codFee">
              <el-input v-model="formData.codFee" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item style="width: auto;margin-top: 20px;" prop="isUnpackEnabled">
              <el-switch
                v-model="formData.isUnpackEnabled"
                :active-text="$lang('是否允许客户开箱验视')">
              </el-switch>
            </el-form-item>
            <el-form-item :label="$lang('是否购买赔偿上限服务')" prop="insured" class="insured-info">
              <Base-Select :clearable="false" v-model="formData.insured" :dic="insuredDic" :disabled="formData.goodsTypeName === '文件' || formData.paymentModeName === 'PP_PM' || !insureSwitch"
                           :placeholder="$lang('请选择')" @change="changeInsured" :props="{label:'name' ,value:'code'}"></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('货物价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
              <!-- <el-input  @keyup.enter.native="searchData(false)" v-model="formData.declaredValue" :placeholder="$lang('请输入')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
              <el-input-number v-model="formData.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="0" :controls="false" :min="0" :max="8000"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('赔偿上限服务费')" prop="insuredValue" v-show="formData.insured===1">
              <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item v-if="formData.insured===1" prop="checked" style="width:250px;margin-top: 20px;" >
              <el-checkbox v-model="formData.checked">{{ $lang('我已阅读并同意') }}</el-checkbox>
              <a class="insurance-clause" :href="insuranceClauseUrl" target="_blank">{{ $lang('赔偿上限服务') }}</a>
            </el-form-item>
            <!-- 是否签回单 -->
            <!-- <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
                <template slot="label"> <span :title="$lang('是否签回单')">{{$lang('是否签回单')}}</span></template>
                <Base-Select :clearable="false"
                 v-model="formData.signReceipt"
                 :dic="signReceiptDic"
                 :disabled="formData.paymentModeName === 'PP_PM' "
                 :placeholder="$lang('请选择')"
                 @change="changeSignReceipt"
                 :props="{label:'name' ,value:'code'}">
                 </Base-Select>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('回单管理费')" prop="receiptFreight" v-show="formData.signReceipt===1">
                <el-input v-model="formData.receiptFreight" :disabled="true"></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$lang('下单数量')" >
                <el-input-number v-model="formData" :min="1" :max="99"></el-input-number>
            </el-form-item>
              <br>
                  <el-form-item :label="$lang('备注')" prop="remarks" class="el-form-item el-form-item--small" style="width:50%">
                         <el-input v-model="formData.remarks" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="100" resize="none" ></el-input>
                 </el-form-item> -->
            <br>
            <el-form-item :label="$lang('备注')" prop="remarks" class="el-form-item el-form-item--small" style="width:50%">
              <el-input v-model="formData.remarks" :placeholder="$lang('请输入')" type="textarea" :rows="4" show-word-limit :maxlength="200" resize="none"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

    </el-form>
    <div class="bc-bottom">
      <el-button type="primary" @click="saveSubmit('sizeForm')" :loading="keyBtn" class="h48">{{ $lang('立即下单') }}</el-button>
    </div>
    <!-- </div> -->
    <SmartSpot v-model="smartSpot"></SmartSpot>
    <AddressBook v-model="addrBook" :selectType="selectType" @single-row-select="singleRowSelect" ref='address'></AddressBook>
    <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>

  </div>
</template>
<script>
import { RESPONSE_SUCCESS } from '@constants'
import { RULES, checkAddressFormat, integerWeight, checkGoodsName, phoneAndMobile, isNull } from '@/utils/rules'
import { DIC } from '@constants'
import SmartSpot from './SmartSpot'
import AddressBook from './AddressBook'
import {
  vipOrderAdd,
  reqAddressList,
  getComCost,
  getSettlement,
  getComputationCost,
  getDefaultAddress,
  printOrders,
  getReceiptFee,
  queryAddressAnalysisAddress,
  getsysCurrencyType,
  customerCod,
  getList,
  getShortAddress, judgeShortAddress
} from '@/api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import * as Api from '@api/base/public'
import { getCalc } from '@/api/module/customer'
import { mapActions } from 'vuex'
import { copyText } from '@/utils/util'

export default {
  name: 'SingleOrder',
  components: {
    SmartSpot,
    AddressBook,
    InsuredStatement,
  },
  data() {
    return {
      DIC,
      COM_HTTP: {
        reqAdd: vipOrderAdd,
      },
      showClick: false,
      printOptions: {
        btnTitle: '下单并打印',
        btnType: 'primary',
        isHideIcon: true,
      },
      prodectData: [], // 产品list
      provinceArray: [],
      printOrder: false,
      keyBtn: false,
      keyBtn1: false,
      paidOption: true,
      getOrderId: '', // 获取下单并打印的订单id
      rules: {
        senderName: [RULES.required, { validator: isNull }],
        // senderMobilePhone: [RULES.required, { validator: phoneNums }],
        senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        senderProvinceName: [RULES.requiredSelect],
        senderCityName: [RULES.requiredSelect],
        // senderAreaName: [RULES.requiredSelect],
        // codCurrencyTypeName: [RULES.requiredSelect],
        senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        // senderStreet: [RULES.requiredTrim],
        // codMoney: [RULES.required, { validator: isNull }],
        receiverName: [RULES.required, { validator: isNull }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [{ validator: phoneAndMobile }],
        // receiverMobilePhone: [RULES.required, { validator: phoneNums }],
        receiverProvinceName: [RULES.requiredSelect],
        receiverCityName: [RULES.requiredSelect],
        // receiverAreaName: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        // receiverStreet: [RULES.requiredTrim],
        goods: [RULES.required],
        goodsName: [RULES.required, { validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        // packageNumber: [RULES.required],
        payment: [RULES.requiredSelect],
        // paidMode: [RULES.requiredSelect],
        insured: [RULES.requiredSelect],
        expressType: [RULES.requiredSelect],
        isUnpackEnabled: [RULES.required],
        checked: [RULES.requiredSelect, {
          validator: (rule, value, callback) => {
            if (value === false) {
              callback(new Error(this.$lang('请选择')))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        senderShortAddress: [RULES.codeNumber],
        senderBuildingNumber: [RULES.twenty],
        senderReferenceNumber: [RULES.twenty],
        receiverShortAddress: [RULES.codeNumber],
        receiverBuildingNumber: [RULES.twenty],
        receiverReferenceNumber: [RULES.twenty]
      },
      addrBook: false,
      smartSpot: false,
      infoVisible: false, // 赔偿上限服务费声明弹窗
      defaultFormData: {},
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称
        senderStreet: '', // 寄件街道,
        // senderPhoneAreacode: '+966', // 寄件电话区号
        senderPostalCode: '', // 寄件邮编
        senderEmail: '', // 寄件邮箱
        senderProvince: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        receiverName: '', // 收件人姓名,
        // receiverPhoneAreacode: '+966', // 收件电话区号
        receiverMobilePhone: '', // 收件人手机号,
        receiverTelphone: '',
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称
        receiverStreet: '', // 收件街道,
        receiverPostalCode: '', // 收件邮编
        receiverEmail: '', // 收件邮箱
        receiverProvince: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        insured: 0, // 是否购买赔偿上限服务1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: 0, // 赔偿上限服务费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 物品重量,
        packageNumber: 1, // 物品件数,
        payment: { code: 'PP_PM', name: this.$lang('Monthly'), id: 42 }, // 结算方式
        paidMode: {}, // 支付方式
        paidModeCode: '', // 支付方式code
        paidModeName: '', // 支付方式名称
        paidModeId: '', // 支付方式id
        paymentModeId: '42', // 结算方式id,
        paymentModeCode: 'PP_PM', // 结算方式编码,
        paymentModeName: this.$lang('Monthly'), // 结算方式名称,
        expressType: { code: 'EZ', name: this.$lang('Standard'), id: 97, lightThrowingCoefficient: 5000 }, // 产品类型
        expressTypeId: '', // 产品id
        expressTypeCode: 'EZ', // 产品类型code
        expressTypeName: this.$lang('Standard'), // 产品类型name
        codMoney: '', // 代收货款金额,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxNumber: 0, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        boxTotalPrice: 0, // 箱材总价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量
        customerOrderId: '',
        senderCompany: '',
        receiverCompany: '',
        checkSenderFlag: '', // 寄件人保存至地址簿
        checkReceiverFlag: '', // 寄件人保存至地址簿
        signReceipt: 0, // 签回单 0否 1是
        receiptFreight: 0, // 回单金额
        codCurrencyTypeName: '', // 代收货款币别
        codCurrencyTypeCode: '', // 代收货款币别code
        platformName: '', // 平台
        customerAccount: '', // 客户账号
        isUnpackEnabled: 0,
        taxation: 0, // 税率
        senderShortAddress: '', // 寄件短地址
        receiverShortAddress: '', // 收件短地址
      },
      codFlag: false,
      phoneVal1: '',
      phoneVal2: '',
      value: '',
      cityList: [],
      cityList2: [],
      areaList: [],
      areaList2: [],
      // codCurrencyType: [{ codCurrencyTypeCode: 'AED', codCurrencyTypeName: 'AED' }, { codCurrencyTypeCode: 'USD', codCurrencyTypeName: 'USD' }],
      codCurrencyType: [],
      receiptFreight: 0,
      checkSenderFlag: false,
      checkReceiverFlag: false,
      codIsInput: true,
      codNumber: 3000, // 代收货款最大值
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds',
      },
      selectType: 1,
      sendAddressData: {
        formProps: {
          provinceIdProp: 'senderProvinceId',
          provinceNameProp: 'senderProvinceName',
          cityIdProp: 'senderCityId',
          cityNameProp: 'senderCityName',
          // areaIdProp: 'senderAreaId',
          // areaNameProp: 'senderAreaName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
          // areaIdProp: 'receiverAreaId',
          // areaNameProp: 'receiverStreet',
        },
        defaultData: {},
      },
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      signReceiptDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      // payTypesDic: [{ code: 'PP_PM', name: this.$lang('寄付月结'), id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: this.$lang('寄付现结'), id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: this.$lang('到付现结'), id: 321, type: 'ZD106' }],
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      senderProvinceName: this.$lang('省份'),
      senderCityName: this.$lang('寄件城市'),
      senderAreaName: this.$lang('寄件区域'),
      receiverProvinceName: this.$lang('省份'),
      receiverCityName: this.$lang('收件城市'),
      receiverAreaName: this.$lang('收件区域'),
      senderExpressTypeData: [],
      receiverExpressTypeData: [],
      senderShortAddressParseResults: '', // 寄件短地址解析结果
      receiverShortAddressParseResults: '' // 收件短地址解析结果
    }
  },
  created() {
    this.getProList()
    this.getList()
    this.getCurrencyTypeList()
    this.fromType = this.comeFrom
    if (this.id) {
      this.getDetail()
    }
    if (this.formData.insured === 1) { // 是否购买赔偿上限服务1是，0否,
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
    // this.getReceiptFee() // 获取回单金额
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    insureSwitch() {
      return (this.$store.state.base.user || {}).insureSwitch === 1
    },
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    someExpressTypeData() {
      return this.receiverExpressTypeData.filter(i => this.senderExpressTypeData.some(j => j.productCode === i.productCode))
    },
    isReverse() {
      const { expressTypeCode } = this.formData
      return expressTypeCode === 'Reverse' || expressTypeCode === `Reverse${this.countryCode}` || expressTypeCode === 'ReverseKW'
    },
    senderShortAddressDisabled() {
      return !(this.senderShortAddressParseResults)
    },
    receiverShortAddressDisabled() {
      return !(this.receiverShortAddressParseResults)
    },
    insuranceClauseUrl() {
      return this.$store.state.base.user.countryCode === 'KSA' ? 'https://htcs.jtexpress.com.cn/content?consultativeCode=XYBMNJF83QQNSI' : 'https://htcs.jtexpress.com.cn/content?consultativeCode=XYBM6T86Y55MHC'
    }
  },
  watch: {
    someExpressTypeData: {
      handler(arr) {
        console.log('相同的产品类型------------->>', arr)
        // const newArr = arr.filter(item => item.productName !== 'Reverse')
        const newArr = arr
        if (newArr && newArr.length) {
          this.formData.expressType = newArr[0]
          this.formData.expressTypeCode = newArr[0].productCode
          this.formData.expressTypeName = newArr[0].productName
        } else {
          if (this.receiverExpressTypeData.length > 0 && this.senderExpressTypeData.length > 0) {
            this.formData.expressType = []
            this.formData.expressTypeId = ''
            this.formData.expressTypeCode = ''
            this.formData.expressTypeName = ''
            this.$message.error(this.$lang('产品类型不匹配，无法下单'))
          }
        }
      },
      immediate: false,
      deep: true,
    },
    'countryCode': {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.senderProvinceName = that.$lang('寄件酋长国')
          that.senderCityName = that.$lang('寄件区域')
          that.receiverProvinceName = that.$lang('收件酋长国')
          that.receiverCityName = that.$lang('收件区域')
        }
      },
      immediate: true,
    },
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        // let paramNum = 0
        // if (!this.formData.taxation && this.formData.taxation !== 0) {
        //   paramNum = 0
        // } else {
        //   paramNum = this.formData.taxation
        // }
        // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
        // console.log('uuuuu', resNum)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    },
    // 产品类型
    async 'formData.expressType'(val) {
      const { productCode: expressTypeCode, productName: expressTypeName } = val
      console.log('77777', expressTypeCode + ',' + expressTypeName)
      const taxationVal = this.prodectData.find(item => item.code === expressTypeCode)
      this.formData.taxation = taxationVal ? taxationVal.taxRate : 0
      console.log('88888', this.formData.taxation)
      Object.assign(this.formData, { expressTypeCode, expressTypeName })
      const { senderCityName, receiverCityName, packageTotalWeight } = this.formData
      if (senderCityName && receiverCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        console.log(222222222)
        Object.assign(this.formData, res)
      }
      const res = await this.getComputationCost(this.formData)
      // let paramNum = 0
      // if (!this.formData.taxation && this.formData.taxation !== 0) {
      //   paramNum = 0
      // } else {
      //   paramNum = this.formData.taxation
      // }
      // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
      // console.log('uuuuu', resNum)
      Object.assign(this.formData, { insuredValue: res })
      // Reverse 禁用报价费勾选
      if (this.isReverse) {
        this.codFlag = false
        this.codIsInput = true
        this.formData.codCurrencyTypeName = ''
        this.formData.codCurrencyTypeCode = ''
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    },
    // 结算方式
    async 'formData.payment'(val) {
      // console.log(val)
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      if (val.code === 'PP_CASH') {
        this.paidOption = false
      } else {
        this.paidOption = true
        this.formData.paidMode = ''
      }
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持赔偿上限服务
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.formData.insuredValue = 0
        this.formData.receiptFreight = 0
      }
      console.log(this.formData)
    },
    // 支付方式
    async 'formData.paidMode'(val) {
      const { id: paidModeId, code: paidModeCode, name: paidModeName } = val
      Object.assign(this.formData, { paidModeId, paidModeCode, paidModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      console.log(this.formData)
    },
    // 运费计算
    async 'formData.senderCityName'(val) {
      const { receiverCityName, packageTotalWeight } = this.formData
      if (receiverCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费计算
    async 'formData.receiverCityName'(val) {
      const { senderCityName, packageTotalWeight } = this.formData
      if (senderCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 运费重量
    async 'formData.packageTotalWeight'(val) {
      const { senderCityName, receiverCityName } = this.formData
      if (senderCityName && receiverCityName && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 箱材规格计算
    async 'formData.boxStandard'(val) {
      const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res, {
        // 箱材规格id
        boxStandardId,
        // 箱材规格名称
        boxStandardName,
        // 箱材单价
        boxPrice,
      })
    },
    // 箱材数量
    async 'formData.boxNumber'(val) {
      const { boxStandardId, boxStandardName, boxPrice } = this.formData
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.formData, res)
    },
    // 赔偿上限服务费计算
    async 'formData.declaredValue'(val) {
      const { goods, insured, expressTypeCode } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.formData)
        // let paramNum = 0
        // if (!this.formData.taxation && this.formData.taxation !== 0) {
        //   paramNum = 0
        // } else {
        //   paramNum = this.formData.taxation
        // }
        // const resNum = Math.round(parseFloat(res) * (parseFloat(paramNum) / 100 + 1) * 100) / 100
        // console.log('uuuuu', resNum)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },

    // 代收货款手续费计算
    async 'formData.codMoney'(val) {
      const { codMoney } = this.formData
      const { decimalPoint } = this.userInfo // 货币小数位数
      if (parseFloat(codMoney) > 0) {
        if (parseFloat(codMoney) > this.codNumber) {
          this.$message.error(this.$lang('代收货款金额超额，最高限额为') + this.codNumber)
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.')[1].length > (decimalPoint || 6)) {
          this.$message.error(`${this.$lang('代收货款不能超过')} ${decimalPoint || 6} ${this.$lang('位小数！请重新输入')}`)
          this.formData.codMoney = ''
          this.formData.codFee = ''
          return
        }
        const codFeeParam = { collectionfee: codMoney }
        const res = await getCalc(codFeeParam)
        Object.assign(this.formData, { codFee: (res.data !== undefined && res.data !== null ? res.data : 0) })
      } else {
        this.formData.codMoney = ''
        this.formData.codFee = ''
      }
    },
    'formData.senderShortAddress'(val) {
      if (!val) {
        this.senderShortAddressParseResults = ''
      }
    },
    'formData.receiverShortAddress'(val) {
      if (!val) {
        this.receiverShortAddressParseResults = ''
      }
    }
  },
  mounted() {
    // 寄件人默认信息
    this.getDefaultAddress({ type: 1 })
    // 收件人默认信息
    this.getDefaultAddress({ type: 2 })
  },
  methods: {
    ...mapActions(['UPDATE_PRINT_STOCK']),
    // 解析短地址
    async judgeShortAddress(e, type, prop) {
      try {
        const { value } = e.target
        if (value) {
          const regex = /^[A-Za-z]{4}\d{4}$/
          if (!regex.test(value)) {
            this.formData[prop] = ''
            this.$message.error(this.$lang('不符合短地址规则'))
            return
          }
          const { code, data } = await judgeShortAddress({ shortAddress: value })
          if (code === RESPONSE_SUCCESS && data && data === true) {
            this.getShortAddress(e, type)
          } else {
            this[type] = ''
            this.formData[prop] = ''
            this.$message.error(this.$lang('未找到该短地址对应的地址，请核实后重试。'))
          }
        } else {
          this[type] = ''
          this.formData[prop] = ''
        }
      } catch (error) {
        this[type] = ''
      }
    },
    async getShortAddress(e, type) {
      try {
        const { value } = e.target
        if (value) {
          const { code, data, msg } = await getShortAddress({ shortAddress: value })
          if (code === RESPONSE_SUCCESS) {
            this[type] = data || ''
          } else {
            this[type] = ''
            this.$message.error(msg)
          }
        } else {
          this[type] = ''
        }
      } catch (error) {
        this[type] = ''
      }
    },
    // 复制短地址解析结果
    handleCopy(data) {
      copyText(data)
      this.$message.success(this.$lang('复制成功'))
    },
    beforePrint() {
      const userInfo = this.userInfo
      if (userInfo.surfaceFormat === 1) {
        this.$alert(this.$lang('请先到我的资料里设置面单格式'), this.$lang('提示'), {
          confirmButtonText: this.$lang('确定'),
        })
      } else {
        this.printOrder = true
        this.saveSubmit('sizeForm')
      }
    },
    // 获取打印数据
    async getPrintData(type) {
      const ids = [this.getOrderId]
      const params = { ids: ids, printType: type, isVip: true }
      const { code, msg, data } = await printOrders(params)
      if (code === 1) {
        if (data.length) this.$message.success(this.$lang('已生成打印数据，正在打印中...'))
        this.printOrder = false
        setTimeout(() => {
          // 更新库存面单
          if (this.exportStatus !== 'already_print') {
            this.UPDATE_PRINT_STOCK(true)
          }
        }, 1100)
        return data || []
      } else {
        this.$message.error(this.$lang(msg))
        return []
      }
    },

    // 获取基础数据
    async getList() {
      const { data, code, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        this.prodectData = data['appProductTypeVOList']
        console.log(555555, this.prodectData)
      } else {
        this.$message.error(msg)
      }
    },

    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        // data.forEach(item => {
        //   item.products = item.products.filter(item => item.productName !== 'Reverse') || []
        // })
        this.provinceArray = data
        console.log('provinceArray', this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },

    // 获取币别  sysCurrencyType/list
    async getCurrencyTypeList() {
      const { data, code, msg } = await getsysCurrencyType()
      var dataList = []
      if (code === RESPONSE_SUCCESS) {
        for (let p = 0; p < data.length; p++) {
          dataList.push({ codCurrencyTypeCode: data[p].coding, codCurrencyTypeName: data[p].name })
        }
        // console.log(dataList)
        this.codCurrencyType = dataList
      } else {
        this.$message.error(msg)
      }
    },

    dataProvinceChange(value, flag) {
      console.log(value)
      this.getCityList(value, flag)
    },

    // 是否代收货款
    async checkCod(val) {
      if (val) {
        const res = await customerCod({ customerCode: this.userInfo.customerCode })
        // console.log(res)
        if (res !== undefined && res.data !== null && res.data.isOpenCod === 1) {
          // if (this.countryCode === 'UAE') {
          //   this.formData.codCurrencyTypeName = 'AED' // 代收货款币别
          //   this.formData.codCurrencyTypeCode = 'AED' // 代收货款币别code
          // } else {
          //   this.formData.codCurrencyTypeName = 'SAR' // 代收货款币别
          //   this.formData.codCurrencyTypeCode = 'SAR' // 代收货款币别code
          // }
          this.formData.codCurrencyTypeName = this.codCurrencyType[0].codCurrencyTypeName // 代收货款币别
          this.formData.codCurrencyTypeCode = this.codCurrencyType[0].codCurrencyTypeCode // 代收货款币别
          this.codNumber = res.data.maxCollectionMoney
          this.codIsInput = false
        } else {
          this.$message.error(this.$lang('您未开通代收货款服务，请联系合作网点！'))
        }
      } else {
        this.formData.codCurrencyTypeName = '' // 代收货款币别
        this.formData.codCurrencyTypeCode = '' // 代收货款币别code
        this.formData.codFee = '' // 代收货款手续费
        this.codIsInput = true
      }
    },

    dataCityChange(value, num) {
      if (this.userInfo.countryId === 1) {
        this.getAreaList(value, num)
      }
      if (num === 1) {
        this.formData.senderCityId = value
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.formData.senderCityName = obj.nativeName
        this.senderExpressTypeData = obj.products || []
      } else {
        this.formData.receiverCityId = value
        const obj = this.cityList2.find((item) => {
          return item.id === value
        })
        this.formData.receiverCityName = obj.nativeName
        this.receiverExpressTypeData = obj.products || []
      }
      // this.getCityList(value, num)
    },
    // 获取城市数据
    async getCityList(parentId, flag) {
      // const { data, code, msg } = await this.$selectApi.reqSysArea({ parentId })
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        // 过滤掉Reverse的产品类型数据
        // data.forEach(item => {
        //   item.products = item.products.filter(item => item.productName !== 'Reverse') || []
        // })
        if (flag === 1) {
          this.cityList = data
          this.formData.senderProvinceId = parentId
          this.formData.senderCityId = '' // 修改省市区
          this.formData.senderCityName = '' // 修改省市区
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.formData.senderProvinceName = obj.nativeName
          this.senderExpressTypeData = data[0].products || []
        } else {
          this.cityList2 = data
          this.formData.receiverProvinceId = parentId
          this.formData.receiverCityId = '' // 修改省市区
          this.formData.receiverCityName = '' // 修改省市区
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.formData.receiverProvinceName = obj.nativeName
          this.receiverExpressTypeData = data[0].products || []
        }
        console.log('senderExpressTypeData--------->>', this.senderExpressTypeData)
        console.log('receiverExpressTypeData-------->>', this.receiverExpressTypeData)
      } else {
        this.$message.error(msg)
      }
    },
    dataAreaChange(value, flag) {
      if (flag === 1) {
        this.formData.senderAreaId = value
        const obj = this.areaList.find((item) => {
          return item.id === value
        })
        this.formData.senderAreaName = obj.nativeName
      } else {
        this.formData.receiverAreaId = value
        const obj = this.areaList2.find((item) => {
          return item.id === value
        })
        this.formData.receiverAreaName = obj.nativeName
      }
    },
    // 获取区域数据
    async getAreaList(parentId, flag) {
      const { code, data, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        console.log('areaList =======>', data)
        if (flag === 1) {
          this.areaList = data
          this.formData.senderAreaName = ''
          this.formData.senderAreaId = ''
        } else {
          this.areaList2 = data
          this.formData.receiverAreaName = ''
          this.formData.receiverAreaId = ''
        }
      } else {
        this.$message.error(msg)
      }
    },
    // // 获取打印数据
    // async getPrintData(type) {
    //   return [this.formData]
    // },
    discern(type) {
      let text
      switch (type) {
        case 0:
          if (!this.formData.analysisAddress) {
            return
          }
          text = this.formData.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  senderName: person,
                  senderMobilePhone: this.filterPhone(phonenum),
                  senderDetailedAddress: detail,
                  senderProvince: {
                    senderProvinceName: province,
                    senderProvinceId: provinceCode,
                    senderCityId: cityCode,
                    senderCityName: city,
                    senderAreaId: countyCode,
                    senderAreaName: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.formData.analysisAddress = ''
          break
        case 2:
          if (!this.formData.analysisAddress1) {
            return
          }
          text = this.formData.analysisAddress1
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  receiverName: person,
                  receiverMobilePhone: this.filterPhone(phonenum),
                  receiverDetailedAddress: detail,
                  receiverProvince: {
                    receiverProvinceName: province,
                    receiverProvinceId: provinceCode,
                    receiverCityId: cityCode,
                    receiverCityName: city,
                    receiverAreaId: countyCode,
                    receiverStreet: county,
                  },
                }
                Object.assign(this.formData, obj)
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 3:
          this.formData.analysisAddress1 = ''
          break
        default:
          break
      }
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    // 运费计算
    async calcStandardCost(data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, packageTotalWeight, paymentModeId, expressTypeCode } = this.formData
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId && expressTypeCode) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
      }
      // 返回结果
      return {
        // ...result,
        ...obj,
      }
    },
    // 获取默认地址
    async getDefaultAddress(param) {
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          this.singleRowSelect(data, param.type)
        }
        // this.defaultFormData = commonFun.deepClone(this.formData)
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 箱材规格计算
    async calcBoxStandard({ boxStandardId, boxStandardName, boxPrice } = {}) {
      const { boxNumber } = this.formData
      // 箱数量
      const boxTotalPrice = this.$common.floatNumSub(boxNumber ? boxNumber * boxPrice : 0)
      return {
        // 箱材总价格
        boxTotalPrice,
      }
    },
    // 打开地址
    open(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    singleRowSelect(data, type) {
      if (!data.cityId) {
        return
      }
      const { name, mobile, detailedAddress, companyName, reserveMobile } = data
      if (type === 1) { // 1寄件2取件
        this.formData.senderName = name // 寄件人姓名,
        this.formData.senderMobilePhone = this.filterPhone(mobile) // 寄件人手机号
        this.formData.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.formData.senderCompany = companyName
        this.curentSend = data
        this.handleProvice(data, 1)
      } else if (type === 2) {
        this.formData.receiverName = name // 收件人姓名,
        this.formData.receiverMobilePhone = this.filterPhone(mobile) // 收件人手机号
        this.formData.receiverTelphone = this.filterPhone(reserveMobile) // 收件人备用手机号
        this.formData.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.formData.receiverCompany = companyName
        this.curentReceiver = data
        this.handleProvice(data, 2)
      }
    },
    /**
     * 是否购买赔偿上限服务
     */
    changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.declaredValue = ''
        this.formData.insuredValue = 0
      }
    },
    /**
     * 是否签回单
     */
    changeSignReceipt(val) {
      if (val === 0) {
        this.formData.receiptFreight = 0
      } else if (val === 1) {
        this.formData.receiptFreight = this.receiptFreight
      }
    },
    // 收件人姓名或者电话改变
    changeReceiverName(item) {
      this.formData.receiverName = item.name
      this.formData.receiverMobilePhone = this.filterPhone(item.mobile)
      this.formData.receiverTelphone = this.filterPhone(item.reserveMobile)
      this.formData.receiverCompany = item.companyName
      this.formData.receiverDetailedAddress = item.detailedAddress
      this.handleProvice(item, 2)
    },
    // 寄件人姓名或者电话改变
    changeSenderName(item) {
      this.formData.senderName = item.name
      this.formData.senderMobilePhone = this.filterPhone(item.mobile)
      this.formData.senderCompany = item.companyName
      this.formData.senderDetailedAddress = item.detailedAddress
      this.handleProvice(item, 1)
    },
    // 表单保存  立即下单
    async saveSubmit(formName) {
      // console.log(this.value)
      console.log(this.formData)
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持赔偿上限服务'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('货物价值必须大于0'))
        return
      }
      this.codCurrencyType.map((item) => {
        if (this.formData.codCurrencyTypeName === item.codCurrencyTypeName) {
          this.formData.codCurrencyTypeCode = item.codCurrencyTypeCode
        }
      })
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.printOrder) {
            this.keyBtn1 = true
          } else {
            this.keyBtn = true
          }
          if (this.formData.insured === 0) this.formData.declaredValue = ''
          this.formData.packageChargeWeight = this.formData.packageTotalWeight
          this.formData.boxStandardCode = this.formData.boxStandard ? this.formData.boxStandard.code : ''
          this.formData.boxNumber = this.formData.boxStandard ? this.formData.boxNumber : null
          this.formData.checkReceiverFlag = this.checkReceiverFlag ? 1 : 0
          this.formData.checkSenderFlag = this.checkSenderFlag ? 1 : 0
          this.formData.needDispatch = this.userInfo.scheduleType
          this.formData.isUnpackEnabled = this.formData.isUnpackEnabled ? 1 : 0
          if (this.isReverse) {
            this.formData.productDescription = 'Reverse' // 产品类型: 退货
            this.formData.returnType = 1 // 退货订单
          } else {
            this.formData.productDescription = '' // 产品类型: 默认
            this.formData.returnType = 0 // 普通下单
          }
          this.vipOrderAdd(this.formData)
        } else {
          return false
        }
      })
    },
    async vipOrderAdd(reqData) { // 新增订单
      try {
        const resData = await vipOrderAdd(reqData)
        if (resData.code === RESPONSE_SUCCESS) {
          this.getOrderId = resData.data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success',
          })
          if (this.printOrder) {
            const userInfo = this.userInfo
            const value = userInfo.surfaceFormat === 2 ? 'oneLinkPage' : 'twoLinkPage'
            this.$refs.print.toPrint(value)
            this.keyBtn1 = false
          } else {
            this.keyBtn = false
          }

          // this.formData = commonFun.deepClone(this.defaultFormData)
          this.senderExpressTypeData = []
          this.receiverExpressTypeData = []
          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          this.codFlag = false
          this.codIsInput = true
          // 寄件人默认信息
          this.getDefaultAddress({ type: 1 })
          // 收件人默认信息
          this.getDefaultAddress({ type: 2 })
          this.$router.push({ path: 'redirect/singleOrder' })
          this.formData.senderPostalCode = ''
          this.formData.senderEmail = ''
          this.formData.receiverPostalCode = ''
          this.formData.receiverEmail = ''
        } else if (resData.code === 149010023) {
          this.$message.warning(resData.msg)
          this.formData.senderProvinceId = ''// 收件省份id,
          this.formData.senderProvinceName = ''// 收件省份名称,
          this.formData.senderCityId = ''// 收件城市id,
          this.formData.senderCityName = ''// 收件城市名称,
          this.formData.senderAreaId = '' // 收件区域id,
          this.formData.senderAreaName = '' // 收件区域id,
          this.formData.senderStreet = '' // 收件区域名称,
          this.formData.senderProvince = '' // 收件区省/市/区
          this.formData.senderProvince = ''
          this.keyBtn = false
        } else if (resData.code === 149010024) {
          this.$message.warning(resData.msg)
          this.formData.receiverProvinceId = ''// 收件省份id,
          this.formData.receiverProvinceName = ''// 收件省份名称,
          this.formData.receiverCityId = ''// 收件城市id,
          this.formData.receiverCityName = ''// 收件城市名称,
          this.formData.receiverAreaId = '' // 收件区域id,
          this.formData.receiverAreaName = '' // 收件区域id,
          this.formData.receiverStreet = '' // 收件区域名称,
          this.formData.receiverProvince = '' // 收件区省/市/区
          this.keyBtn = false
        } else {
          this.$message.error(resData.msg)
          this.keyBtn = false
        }
      } catch (error) {
        this.keyBtn1 = false
        this.keyBtn = false
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smModeType = 1
            break
          case 319:
            smModeType = 2
            break
          case 321:
            smModeType = 3
            break
        }
      }
      // 服务方式-serviceMethodCode 写死寄件上门 01
      const reqData = { startAddressId, endAddressId, number, productTypeCode, serviceMethodCode: '01', ...{ smMode: smModeType }}
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 赔偿上限服务费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        productTypeCode: param.expressTypeCode
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, packageTotalWeight, type) {
      const reqData = { providerId, cityId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 城市重新赋值
    handleProvice(row, type) {
      console.log('城市重新')
      const { cityId, cityName, provinceId, provinceName, areaId, areaName, street } = row
      if (type === 1) {
        this.formData.senderProvinceId = provinceId
        this.formData.senderProvinceName = provinceName
        this.formData.senderCityId = cityId
        this.formData.senderCityName = cityName
        this.formData.senderStreet = street
        if (this.userInfo.countryId === 1) {
          this.formData.senderAreaId = areaId
          this.formData.senderAreaName = areaName
          this.getAreaInfo(cityId, 1)
        }
        this.getCityInfo(provinceId, 1)
      } else {
        this.formData.receiverProvinceId = provinceId
        this.formData.receiverProvinceName = provinceName
        this.formData.receiverCityId = cityId
        this.formData.receiverCityName = cityName
        this.formData.receiverStreet = street
        if (this.userInfo.countryId === 1) {
          this.formData.receiverAreaId = areaId
          this.formData.receiverAreaName = areaName
          this.getAreaInfo(cityId, 2)
        }
        this.getCityInfo(provinceId, 2)
      }
    },
    // 查询数据
    async getAreaInfo(parentId, flagType) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.areaList = data
        } else {
          this.areaList2 = data
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 查询数据
    async getCityInfo(provinceId, flagType) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.cityList = data
          const item = data.find(({ id }) => id === this.formData.senderCityId)
          if (item) this.senderExpressTypeData = item.products || []
        } else {
          this.cityList2 = data
          const item = data.find(({ id }) => id === this.formData.receiverCityId)
          if (item) this.receiverExpressTypeData = item.products || []
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 收件人姓名模糊搜索
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(msg)
        this.loading = false
      }
    },
    // 收件人手机电话模糊搜索
    async remoteReceiverMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人姓名模糊搜索
    async remoteSenderName(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'name'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    // 寄件人手机电话模糊搜索
    async remoteSenderMobilePhone(queryString, cb) {
      this.loading = true
      const param = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      const { data, msg, code } = await reqAddressList(param)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString
          ? diseaseList.filter(this.createFilter(queryString, 'mobile'))
          : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
        // cb(data.records)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },

    createFilter(queryString, type) {
      return disease => {
        return (
          disease[type].toLowerCase().indexOf(queryString.toLowerCase()) !== -1 // 改为===0 就是筛选的数据只是首字匹配的列表项，需要包含输入字的所有列表项改为！==-1
        )
      }
    },

    /**
     * @description 获取回单金额
     */
    async getReceiptFee() {
      const params = {
        customerCode: this.userInfo.customerCode,
      }
      const { data, msg, code } = await getReceiptFee(params)
      if (code === RESPONSE_SUCCESS) {
        this.receiptFreight = data
        this.formData.receiptFreight = this.receiptFreight
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    filterPhone(val) {
      console.log(val)
      if (!val) return ''
      if (val.includes('+86') || val.includes('+966')) return val
      if (val.length === 11) return `+86-${val}`
      if (val.length === 9) return `+966-${val}`
      return val
    },
  },

}
</script>
<style lang="scss" scoped>
.customerStyle {
  ::v-deep .el-input__inner {
    width: 180px;
  }
}

.formPhone {
  ::v-deep .el-form-item__label {
    width: 220px !important;
  }
}

.formPhone {
  ::v-deep .el-form-item__content {
    width: 220px !important;
  }
}

.cod {
  ::v-deep .el-form-item__content {
    margin-top: 22px;
  }
}

.bc-bottom {
  margin: 20px 0;
  text-align: center;
}

.singleOrder {
  padding: 0 24px;
  margin: 20px 0;

  h3 {
    font-size: 20px
  }

  .width100 {
    width: 100%;
  }

  .w360 {
    width: 100%;

    .el-input {
      width: 360px !important;
    }
  }

}

#areaCodeSty {
  width: 80px;
  // span {
  //   width: 80px;
  // }
  .el-input {
    ::v-deep .el-form-item__content {
      width: 80px !important;
    }
  }

  // ::v-deep .el-input__inner {
  //   width: 80px;
  // }
}

.group-title {
  border-bottom: 1px dashed #EEEEEE;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;

  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #E0BD7B;
  }

  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;

    .icon {
      color: #E0BD7B;
      position: absolute;
      overflow: visible;
    }

    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}

.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;

  .el-textarea__inner {
    min-height: 60px;
  }

  .oper {
    position: absolute;
    right: 20px;
    bottom: 5px;
    cursor: pointer;
    color: #333;

    .red {
      color: red;
      margin-right: 20px;
    }
  }
}
.insurance-clause{
  margin-left: 5px;
  color: #e60012;
  border-bottom: 1px solid #e60012;
  cursor: pointer;
  font-style: oblique;
  font-weight: bold;
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content {
  position: relative;

  .btn-insured {
    color: #e60012;;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: -62px;
    display: inline-block;
    height: 22px;
    line-height: 16px;

    &:hover {
      text-decoration: underline;
    }
  }
}

.btn-insured {
  margin: 40px 0 0 30px !important;
}

.el-form-item.declaredValue {
  .el-input-number .el-input__inner {
    text-align: left;
  }
}

.singleOrder {
  .el-form-item__label {
    width: 180px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.label-tip {
  display: flex;
  align-items: center;
}
.tooltip-click {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin: 0 5px;
}

.short-tips {
  a {
    color: #28CFFE;
  }
}
</style>
